import React, { useState } from 'react';
import Spinner from '../../layout/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { Link } from 'react-router-dom';

const ViewSubConditions = (props) => {
  const { condition } = props;
  const { loadingAddSubCon } = useSelector((state) => state.general);

  const [open, setOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const dispatch = useDispatch();

  const handleClickOpen = (index) => {
    setDeleteIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteIndex(null);
  };

  const handleDeleteSubCondition = () => {
    const updatedSubConditions = condition.subConditions.filter((_, i) => i !== deleteIndex);
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: { ...condition, subConditions: updatedSubConditions },
      })
    );
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: 'conditions/updateSubConditions',
        conditionId: condition._id,
        subConditions: Array.isArray(condition.subConditions) ? updatedSubConditions : [],
      })
    );
    handleClose();
  };

  const AddButton = () => {
    const [subConName, setSubConName] = useState('');
    console.log({ subConName });

    return (
      <div className='btn-group'>
        <input
          className='form-control'
          placeholder='New Sub Condition...'
          style={{ textAlign: 'center' }}
          defaultValue={subConName}
          onChange={(e) => setSubConName(e.target.value)}
        />
        {subConName ? (
          <button
            className='btn btn-outline-success'
            disabled={loadingAddSubCon}
            onClick={() => {
              dispatch(generalSet({ reduxField: 'loadingAddSubCon', value: true }));
              dispatch(
                apiAction({
                  reduxField: 'condition',
                  route: 'conditions/updateSubConditions',
                  conditionId: condition._id,
                  subConditions: Array.isArray(condition.subConditions)
                    ? [...condition.subConditions, { name: subConName }]
                    : [{ name: subConName }],
                  setLoading: 'loadingAddSubCon',
                })
              );
              setSubConName('');
            }}
          >
            Save
          </button>
        ) : null}
      </div>
    );
  };

  const AddSubCondition = () => {
    return (
      <>
        <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
          <h2>Sub Conditions</h2>
        </div>
        <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
          <h5 className='text-danger'>No Sub Conditions</h5>
        </div>
        <div className='row d-flex justify-content-center mt-2 pt-lg-0'>
          <h6 className='text-danger'>Add your first sub condition</h6>
        </div>
        <div className='row d-flex justify-content-center mt-2 pt-lg-0'>
          <div className='col-md-4 d-flex justify-content-center'>
            <AddButton />
          </div>
        </div>
      </>
    );
  };

  console.log(condition?._id, !Array.isArray(condition?.subConditions));
  // If no subconditions:
  if (condition?._id && !Array.isArray(condition?.subConditions)) {
    return <AddSubCondition />;
  }
  if (condition?.subConditions.length < 1) {
    return <AddSubCondition />;
  }

  return condition?._id ? (
    <>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h2>Sub Conditions</h2>
      </div>

      <div className='row d-flex justify-content-center mt-2 pt-lg-0'>
        <div className='col-md-4 d-flex justify-content-center'>
          <AddButton />
        </div>
      </div>

      <div className='row d-flex justify-content-center p-2 mt-4 pt-lg-0'>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sub Condition Name</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {condition.subConditions.map((subCondition, index) => (
                <TableRow key={subCondition._id}>
                  <TableCell>{subCondition.name}</TableCell>
                  <TableCell>
                    <Link
                      className='btn btn-sm btn-outline-primary'
                      to={`/subCondition/${condition._id}/${subCondition._id}`}
                    >
                      View
                    </Link>
                    <button className='btn btn-sm btn-outline-danger ml-2' onClick={() => handleClickOpen(index)}>
                      Delete Condition
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{'Delete Sub Condition'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this sub condition?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleDeleteSubCondition} color='primary' autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : (
    <Spinner />
  );
};

export default ViewSubConditions;
